import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { MuestraMensaje } from "../shared/utilerias/notificaciones/notificaciones.component";
import { AuthenticationService } from '../servicios';
import { Router } from '@angular/router';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  muestraMensaje = new MuestraMensaje();
  constructor(
    private authenticationService: AuthenticationService,
    private router: Router
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((err) => {
        //debugger;
        if (err.status === 401) {
          // auto logout if 401 response returned from api
          var Token: string = JSON.parse(localStorage.getItem("currentUser")).token;
          this.authenticationService.deleteLocalStorage();
          this.logout(Token);
          this.router.navigate(["/login"]);
        }
        
        let errorMessage = '¡Ocurrió un error desconocido!';
        if (err.error instanceof ErrorEvent) {
          errorMessage = `Error: ${err.error.message}`;
        } else if (err.error.value?.messageTecnico) {
          errorMessage = `<b>Mensaje:</b> ${err.error.value.messageTecnico}<br><small><i><b>Código:</b> ${err.error.value.statusCode} Controlador: ${err.error.value.controllerName}</i></small>`;          
        } else if (err.error.value) {
          errorMessage = `<b>Mensaje:</b> ${err.error.value.message}<br><small><i><b>Código:</b> ${err.error.value.statusCode} Controlador: ${err.error.value.controllerName}</i></small>`;
        } else if (err.error.message) {
          errorMessage = `<b>Mensaje:</b> ${err.error.message}`;
        }

        this.muestraMensaje.error(errorMessage, "top", "center");

        //const error = err.error.message || err.statusText;
        return throwError(errorMessage);
      })
    );
  }

  async logout(Token){
   await  this.authenticationService.logout(Token);
  }
}